<p-dialog styleClass="acv-modal" [modal]="true" appendTo="body" [visible]="visibility" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ maxWidth: '1230px', width: '100%', minHeight: '200px' }">
  <acv-grid-count-dialog #specialInstructionRef></acv-grid-count-dialog>
  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
      <h4 class="font-poppin text-color-grey4 flex gap-2">
        <span class="font-bold">{{title}}</span>
        <span>({{ date | dateTime }})</span>
      </h4>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="bg-gray-100 font-poppin p-4">
      <h6 class="mb-4 font-bold">{{legActionName}}</h6>
      <div class="grid">
        <div class="col">
          <p class="mb-2">Trailer</p>
          <p class="font-bold">TR-201</p>
        </div>
        <div class="col">
          <p class="mb-2">Truck</p>
          <p class="font-bold">TR-02</p>
        </div>
        <div class="col">
          <p class="mb-2">Driver</p>
          <p class="font-bold">Sameer</p>
        </div>
        <div class="col">
          <p class="mb-2">Origin</p>
          <p class="font-bold">Karachi</p>
        </div>
        <div class="col">
          <p class="mb-2">Destination</p>
          <p class="font-bold">Islamabad</p>
        </div>
        <div class="col">
          <p class="mb-2">Special Instruction</p>
          <p class="font-bold underline cursor-pointer" (click)="onViewClick(['Some special instructions'])">View</p>
        </div>
        <div class="col flex flex-column align-items-center">
          <p class="mb-2">Confirm</p>
          <p-checkbox
            class="acv-checkbox"
            [(ngModel)]="checked" 
            [binary]="true" 
            inputId="binary" />
        </div>
        <div class="col">
          <p class="mb-2">Status</p>
          <button style="cursor: default" pButton [attr.status]="'Not Started'" type="button"
                class="btn-status p-button-outlined">
                Not Started
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
